<template>
  <div class="page-form">
    <h3 class="title">销售计划批导</h3>
    <affix>
      <div class="tools">
        <form-button v-if="conditions.batch_status === 'E001'" type="default" icon="form-advance" @click="confirmImport">导入</form-button>
        <form-button v-if="conditions.batch_status === 'E001' || conditions.batch_status === 'E002'" type="default" icon="form-advance" @click="cancelImport">取消</form-button>
        <form-button type="default" icon="form-advance" @click="$emit('change-action', 'query')">返回</form-button>
      </div>
    </affix>

    <div class="form-container">
      <el-form size="mini" inline disabled label-width="100px">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="批次号">
              <el-input v-model="conditions.batch_number" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="附件名称">
              <el-input v-model="conditions.file_name" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="批导类型">
              <el-input v-model="conditions.batch_type_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="处理状态">
              <el-input v-model="conditions.batch_status_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="导入日期">
              <el-input v-model="conditions.datum" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="批导人">
              <el-input v-model="conditions.batch_name" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="批导明细"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <template #button>
          <table-button name="export" tip="打印" @click="printBatch" />
          <table-button name="export" tip="导出" @click="exportExcel" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :filter-config="{ remote: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="tableColumns"
          :data="gridOptions.data"
          @filter-change="filterChangeEvt"
        />
      </TableCommon>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="打印浏览"
      width="70%"
      top="5vh"
    >
      <iframe :src="url" frameborder="0" style="width: 100%;height: 600px" />
    </el-dialog>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { sapDownloadFile, hexToBytes } from '@/utils/frontExport'
import { apiSaleImportBatchNumDetail, apiSaleImportBatchCancel, apiSalesplanBatchPrint, apiSaleImportBatchConfirm, apiSaleComImportBatchConfirm, apiSalesplanBatchExport } from '@/api/sap/sale-plan'
import tableMixins from '@/utils/tableMixins'
export default {
  mixins: [tableMixins],
  props: ['batchNum'],
  data() {
    return {
      allOptions: {},
      conditions: {
        batch_number: '',
        batch_type: '',
        batch_status: '',
        file_name: '',
        uname: '',
        datum: ''
      },
      url: '',
      showDialog: false,
      selectDataOptions: {},
      tableColumns: [],
      originalData: [], // 保存原始数据，用于本地过滤
      gridOptions: {
        columns: [],
        // 新增
        columns1: [
          { field: 'batch_status_text', title: '处理状态', width: 120, filters: [], filterMultiple: false },
          { field: 'message', title: '消息', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_order', title: '单据编号', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_number', title: '销售计划编号', width: 120, filters: [], filterMultiple: false },
          { field: 'report_type_dscr', title: '提报类型描述', width: 160, filters: [], filterMultiple: false },
          { field: 'report_type', title: '提报类型编码', width: 160, filters: [], filterMultiple: false },
          { field: 'sal_center_name', title: '营销单元描述', width: 160, filters: [], filterMultiple: false },
          { field: 'sal_center', title: '营销单元编码', width: 160, filters: [], filterMultiple: false },
          { field: 'cust_name', title: '客户名称', width: 120, filters: [], filterMultiple: false },
          { field: 'customer', title: '客户编码', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_type_dscr', title: '计划类型描述', width: 160, filters: [], filterMultiple: false },
          { field: 'plan_type', title: '计划类型编码', width: 160, filters: [], filterMultiple: false },
          { field: 'gjahr', title: '年度', width: 120, filters: [], filterMultiple: false },
          { field: 'monat', title: '月份', width: 120, filters: [], filterMultiple: false },
          { field: 'wlybrand', title: '存货分类', width: 120, filters: [], filterMultiple: false },
          { field: 'wlybrand_name', title: '存货分类描述', width: 160, filters: [], filterMultiple: false },
          { field: 'plan_qty', title: '计划量(件)', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_bot', title: '计划量(瓶)', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_amt', title: '计划额(万元)', width: 120, filters: [], filterMultiple: false },
          { field: 'remark', title: '备注', width: 120, filters: [], filterMultiple: false }
        ],
        // 变更
        columns2: [
          { field: 'batch_status_text', title: '处理状态', width: 120, filters: [], filterMultiple: false },
          { field: 'message', title: '消息', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_order', title: '单据编号', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_number', title: '销售计划编号', width: 120, filters: [], filterMultiple: false },
          { field: 'report_type_dscr', title: '提报类型描述', width: 160, filters: [], filterMultiple: false },
          { field: 'report_type', title: '提报类型编码', width: 160, filters: [], filterMultiple: false },
          { field: 'sal_center_name', title: '营销单元描述', width: 160, filters: [], filterMultiple: false },
          { field: 'sal_center', title: '营销单元编码', width: 160, filters: [], filterMultiple: false },
          { field: 'cust_name', title: '客户名称', width: 120, filters: [], filterMultiple: false },
          { field: 'customer', title: '客户编码', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_type_dscr', title: '计划类型描述', width: 160, filters: [], filterMultiple: false },
          { field: 'plan_type', title: '计划类型编码', width: 160, filters: [], filterMultiple: false },
          { field: 'gjahr', title: '年度', width: 120, filters: [], filterMultiple: false },
          { field: 'monat', title: '月份', width: 120, filters: [], filterMultiple: false },
          { field: 'wlybrand', title: '存货分类编码', width: 160, filters: [], filterMultiple: false },
          { field: 'wlybrand_name', title: '存货分类描述', width: 160, filters: [], filterMultiple: false },
          { field: 'plan_qty', title: '本次调整计划量（件）', width: 180, filters: [], filterMultiple: false },
          { field: 'plan_bot', title: '本次调整计划量（瓶）', width: 180, filters: [], filterMultiple: false },
          { field: 'plan_amt', title: '本次调整计划额（万元）', width: 180, filters: [], filterMultiple: false },
          { field: 'futur_adjq', title: '未调整计划量（件）', width: 180, filters: [], filterMultiple: false },
          { field: 'futur_adjbot', title: '未调整计划量（瓶）', width: 180, filters: [], filterMultiple: false },
          { field: 'futur_adja', title: '未调整计划额（万元）', width: 180, filters: [], filterMultiple: false },
          { field: 'adj_reason_text', title: '变更原因', width: 120, filters: [], filterMultiple: false },
          { field: 'remark', title: '备注', width: 120, filters: [], filterMultiple: false }
        ],
        // 新增公司/营销单元
        columns3: [
          { field: 'batch_status_text', title: '处理状态', width: 120, filters: [], filterMultiple: false },
          { field: 'message', title: '消息', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_order', title: '单据编号', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_number', title: '销售计划编号', width: 120, filters: [], filterMultiple: false },
          { field: 'sal_center_name', title: '营销单元描述', width: 160, filters: [], filterMultiple: false },
          { field: 'sal_center', title: '营销单元编码', width: 160, filters: [], filterMultiple: false },
          { field: 'wlybrand_name', title: '存货分类描述', width: 160, filters: [], filterMultiple: false },
          { field: 'wlybrand', title: '存货分类编码', width: 160, filters: [], filterMultiple: false },
          { field: 'gjahr', title: '年度', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_qty', title: '初始计划量（吨）', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_amt', title: '初始计划额（万元）', width: 120, filters: [], filterMultiple: false },
          { field: 'remark', title: '备注', width: 120, filters: [], filterMultiple: false }
        ],
        // 新增公司/营销单元
        columns4: [
          { field: 'batch_status_text', title: '处理状态', width: 120, filters: [], filterMultiple: false },
          { field: 'message', title: '消息', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_order', title: '单据编号', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_number', title: '销售计划编号', width: 120, filters: [], filterMultiple: false },
          { field: 'plan_qty', title: '本次调整计划量（吨）', width: 180, filters: [], filterMultiple: false },
          { field: 'plan_amt', title: '本次调整计划额（万元）', width: 180, filters: [], filterMultiple: false },
          { field: 'adj_reason_text', title: '变更原因', width: 120, filters: [], filterMultiple: false },
          { field: 'remark', title: '备注', width: 120, filters: [], filterMultiple: false }
        ],
        data: []
      }
    }
  },
  created() {
    this.batchNum && this.getDetail()
  },
  methods: {
    async confirmImport() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        head: this.conditions,
        item: this.gridOptions.data
      }
      const isCom = ['V003', 'V004'].includes(this.conditions.batch_type)
      const res = isCom ? await apiSaleComImportBatchConfirm(params) : await apiSaleImportBatchConfirm(params)
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
        // Object.assign(this.conditions, res.data.head)
        // this.gridOptions.data = res.data.item
      } else {
        this.$message.warning(res.message)
      }
      this.getDetail()
    },
    async cancelImport() {
      const params = {
        head: this.conditions,
        user_bp: this.$store.getters.role.USER_BP
      }
      const res = await apiSaleImportBatchCancel(params)
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
      } else {
        this.$message.warning(res.message)
      }
      this.getDetail()
    },
    async exportExcel() {
      const { data } = await apiSalesplanBatchExport({ batch_number: this.conditions.batch_number, mode: 'DOWNLOAD' })
      sapDownloadFile(data, 'EXPORT_PLAN_LIST.xlsx')
    },
    async printBatch() {
      const { data, msgtype, message } = await apiSalesplanBatchPrint({ batch_number: this.conditions.batch_number, mode: 'PRINT' })
      if (msgtype === 'S') {
        var uint8Array = new Uint8Array(hexToBytes(data))
        var blob = new Blob([uint8Array], { type: 'application/pdf' })
        this.url = URL.createObjectURL(blob)
        this.showDialog = true
      } else {
        this.$message.error(message)
      }
    },
    async getDetail() {
      const response = await apiSaleImportBatchNumDetail({ iv_batch_number: this.batchNum })
      const { head, item, field } = response
      Object.assign(this.conditions, head)
      const option = {
        V001: 'columns1',
        V002: 'columns2',
        V003: 'columns3',
        V004: 'columns4'
      }
      this.tableColumns = this.gridOptions[option[this.conditions.batch_type]]
      // 将列配置赋值给 gridOptions.columns，供 filterAllOptions 使用
      // 使用 $set 确保响应式更新
      this.$set(this.gridOptions, 'columns', this.tableColumns)
      // 保存原始数据，用于本地过滤
      this.originalData = item
      this.gridOptions.data = item
      // 在获取数据后统一设置过滤器
      if (field && field.length > 0) {
        // 确保列配置已设置后再处理过滤选项
        // 注意：filterAllOptions 会将字段名转换为小写进行匹配
        this.allOptions = this.filterAllOptions(field, 'xTable')
        // 确保表格列已经加载后再设置过滤器
        // 需要等待表格列完全渲染
        this.$nextTick(() => {
          // 再次等待，确保表格列已经加载到表格实例中
          this.$nextTick(() => {
            if (this.$refs.xTable) {
              this.setFilter('xTable')
            }
          })
        })
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 重写 filterChangeEvt 方法，因为这是详情页面，需要本地过滤
    filterChangeEvt({ filterList, values, column, property }) {
      this.filterList = filterList
      this.condition = this.handleFilterCondition('xTable')

      if (!values.length) {
        delete this.tableFilterData[property]
        // 清除过滤条件后，恢复原始数据
        this.gridOptions.data = this.originalData
        return
      }

      if (values[0] === 'more-option') {
        this.currentFilterField = column
        this.$refs.CustomFilter.show()
        this.currentRef = 'xTable'
        return
      }

      // 执行本地过滤
      this.applyLocalFilter()
    },
    // 本地过滤方法
    applyLocalFilter() {
      let filteredData = [...this.originalData]

      // 根据过滤条件过滤数据
      Object.keys(this.condition).forEach(field => {
        const conditions = this.condition[field]
        if (conditions && conditions.length > 0) {
          filteredData = filteredData.filter(row => {
            return conditions.some(condition => {
              const fieldValue = row[field]
              const filterValue = condition.low

              // 处理为空的情况
              if (condition.low === 'isnull' || condition.low === '') {
                return !fieldValue || fieldValue === '' || fieldValue === null || fieldValue === undefined
              }

              // 处理等于的情况
              if (condition.option === 'EQ') {
                return String(fieldValue) === String(filterValue)
              }

              // 默认使用等于匹配
              return String(fieldValue) === String(filterValue)
            })
          })
        }
      })

      this.gridOptions.data = filteredData
    },
    // 重写 customeFilter 方法，因为这是详情页面，没有 queryData 方法
    customeFilter(text) {
      if (!text) return
      const lastStr = ''
      const keys = Object.keys(this.condition)

      if (!keys.length) {
        this.condition[this.currentFilterField.field] = [
          {
            sign: 'I',
            option: 'EQ',
            low: text,
            high: ''
          }
        ]
      } else {
        keys.forEach(key => {
          if (key === this.currentFilterField.field) {
            this.condition[key].push({
              sign: 'I',
              option: 'EQ',
              low: text,
              high: ''
            })
          } else {
            this.condition[this.currentFilterField.field] = [
              {
                sign: 'I',
                option: 'EQ',
                low: text,
                high: ''
              }
            ]
          }
        })
      }
      // 执行本地过滤
      this.applyLocalFilter()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/BatchImport.vue